import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a81e78a0&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=a81e78a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e78a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a81e78a0')) {
      api.createRecord('a81e78a0', component.options)
    } else {
      api.reload('a81e78a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a81e78a0&scoped=true", function () {
      api.rerender('a81e78a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/empty/index.vue"
export default component.exports